import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { NoteDb } from '../redux/noteDbSlice';
import useCurrentUserId from './useCurrentUserId';

const useNoteDbsByReferences = (referenceIds: (string | undefined | null)[]): [string[], NoteDb[]] => {
  const userId = useCurrentUserId();
  const notes = useSelector((state: RootState) => state.noteDb.notes);
  if (!userId || referenceIds.length === 0) return [[], []];
  const ids = Object.keys(notes).filter(id => notes[id].referenceId && referenceIds.includes(notes[id].referenceId));
  const values = ids.map(id => notes[id]);

  return [ids, values];
}

export default useNoteDbsByReferences;
